import { WidgetDataType, WidgetModel } from 'common/models/widget.model';
// This is used for exporting multipleQuestion widgets to PPTX , checking if missing data so the slides will be sckipped
interface GeoFeature {
  properties: {
    dataCount: number;
  };
}

export function widgetHasData(widget: WidgetModel, data: unknown): boolean {
  if (!widget || !data) return false;

  switch (widget.dataType) {
    case WidgetDataType.LIST: {
      const list = data as { data: unknown[] };
      return Array.isArray(list.data) && list.data.length > 0;
    }

    case WidgetDataType.SERIES: {
      const series = data as {
        groupedList?: { data?: unknown[] }[];
      };
      return (
        Array.isArray(series.groupedList) &&
        series.groupedList.some((group) => Array.isArray(group?.data) && group.data.length > 0)
      );
    }

    case WidgetDataType.GEO: {
      const geo = data as { features?: GeoFeature[] };
      return !!geo.features?.some((feature) => feature?.properties?.dataCount > 0);
    }

    case WidgetDataType.COUNTER:
      return true;

    default:
      return true;
  }
}
